import ParticipantList from "./components/List"
import ParticipantForm from "./components/Form"
import ParticipantView from "./components/View"

let module = "participants"

export default [
  { path: "participants", component: ParticipantList, meta: { module: module, permissions: ["participant-access"] } },
  {
    path: "participants/create",
    component: ParticipantForm,
    props: true,
    meta: { module: module, permissions: ["participant-create"] }
  },
  {
    path: "participants/edit/:id",
    component: ParticipantForm,
    props: true,
    meta: { module: module, permissions: ["participant-edit"] }
  },
  {
    path: "participants/view/:id",
    component: ParticipantView,
    props: true,
    meta: { module: module, permissions: ["participant-access"] }
  }
]
